import { AuthState } from '@okta/okta-auth-js';

import { FuturesBrokers } from '../../services/backend/FuturesBrokers';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesBrokers: () => FuturesBrokers<AuthState> = () => {
  return useBaseApiClient(FuturesBrokers);
};
